<template
    ><svg
        id="Fullscreen"
        xmlns="http://www.w3.org/2000/svg"
        width="17.726"
        height="17.605"
        viewBox="0 0 17.726 17.605"
    >
        <path
            id="Pfad_446"
            data-name="Pfad 446"
            d="M.971,7.285A.866.866,0,0,1,0,6.435V.971A.894.894,0,0,1,.971,0a.894.894,0,0,1,.971.971V6.435A1.03,1.03,0,0,1,.971,7.285Z"
            :class="fillClass + ' transition-fill'"
        />
        <path
            id="Pfad_447"
            data-name="Pfad 447"
            d="M6.435,1.821H.971A.866.866,0,0,1,0,.971.958.958,0,0,1,.971,0H6.435a.866.866,0,0,1,.85.971A.767.767,0,0,1,6.435,1.821Z"
            :class="fillClass + ' transition-fill'"
        />
        <path
            id="Pfad_448"
            data-name="Pfad 448"
            d="M13.971,7.285A.866.866,0,0,1,13,6.435V.971A.894.894,0,0,1,13.971,0a.894.894,0,0,1,.971.971V6.435A1.03,1.03,0,0,1,13.971,7.285Z"
            transform="translate(2.784)"
            :class="fillClass + ' transition-fill'"
        />
        <path
            id="Pfad_449"
            data-name="Pfad 449"
            d="M14.956,1.821H9.371A.958.958,0,0,1,8.4.85.86.86,0,0,1,9.371,0h5.464a.958.958,0,0,1,.971.971A.767.767,0,0,1,14.956,1.821Z"
            transform="translate(1.799)"
            :class="fillClass + ' transition-fill'"
        />
        <path
            id="Pfad_450"
            data-name="Pfad 450"
            d="M.971,15.806A.958.958,0,0,1,0,14.835V9.371A.958.958,0,0,1,.971,8.4a.894.894,0,0,1,.971.971v5.464C1.821,15.442,1.457,15.806.971,15.806Z"
            transform="translate(0 1.799)"
            :class="fillClass + ' transition-fill'"
        />
        <path
            id="Pfad_451"
            data-name="Pfad 451"
            d="M6.435,14.821H.971A.958.958,0,0,1,0,13.85c0-.607.364-.85.971-.85H6.435a.866.866,0,0,1,.85.971A.767.767,0,0,1,6.435,14.821Z"
            transform="translate(0 2.784)"
            :class="fillClass + ' transition-fill'"
        />
        <path
            id="Pfad_452"
            data-name="Pfad 452"
            d="M13.971,15.806A.958.958,0,0,1,13,14.835V9.371a.958.958,0,0,1,.971-.971.894.894,0,0,1,.971.971v5.464C14.821,15.442,14.457,15.806,13.971,15.806Z"
            transform="translate(2.784 1.799)"
            :class="fillClass + ' transition-fill'"
        />
        <path
            id="Pfad_453"
            data-name="Pfad 453"
            d="M14.956,14.821H9.371A.958.958,0,0,1,8.4,13.85.86.86,0,0,1,9.371,13h5.464a.958.958,0,0,1,.971.971A.767.767,0,0,1,14.956,14.821Z"
            transform="translate(1.799 2.784)"
            :class="fillClass + ' transition-fill'"
        />
    </svg>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
    name: "ZoomInIcon",
    props: {
        fillClass: {
            type: String,
            required: true,
        },
    },
});
</script>
